import { BusinessType } from '../../../../data-layer/business/types';
import { UserModel } from '../../../../data-layer/user/types';
import { BusinessRegistrationStatus } from '../../../../mappers/users/toUserModel';

export interface GetBusinessTypeParams {
    currentUser?: UserModel;
    currentBusinessType?: BusinessType;
}

export const getBusinessType = ({ currentUser, currentBusinessType }: GetBusinessTypeParams) => {
    // если зарегистрирован автор, то форсируем этот режим
    if (
        currentUser?.businessRegistrationStatus ===
        BusinessRegistrationStatus.MULTIPLE_ROLE_RESTRICTED
    ) {
        return BusinessType.BLOGGER;
    }

    if (currentBusinessType) {
        return currentBusinessType;
    }

    return BusinessType.BUSINESS;
};
